import React from 'react';

export function StatCard({ value, label, accent = '' }) {
  return (
    <div className={`stat ${accent}`}>
      <div className="stat-val">{value}</div>
      <div className="stat-lbl">{label}</div>
    </div>
  );
}
